export var MobileNavigationStyles = {
  navigationItem: {
    width: '100%'
  }
};